import { Outlet } from "react-router-dom";
import { AdminChrome } from "@/components/admin/AdminChrome";
import { DockProvider } from "@/components/command/DockContext";

/**
 * Shell for the /platform area (D14 platform role — Henoia, cross-org). Mirrors
 * AdminLayout but in the sky/platform accent; reuses AdminChrome, whose
 * BrandSwitcher already exposes the platform mode for `herika-platform` users.
 */
export function PlatformLayout() {
  return (
    <DockProvider>
      <div className="relative min-h-dvh overflow-x-hidden bg-gradient-to-br from-sky-50 via-white to-indigo-50 text-foreground">
        <div aria-hidden className="pointer-events-none fixed inset-0 z-0">
          <div className="absolute inset-0 bg-[radial-gradient(70%_50%_at_15%_-10%,rgba(14,165,233,0.10),transparent_60%)]" />
          <div className="absolute inset-0 bg-[radial-gradient(60%_45%_at_100%_100%,rgba(99,102,241,0.10),transparent_55%)]" />
        </div>

        <AdminChrome />

        <main className="relative z-10">
          <Outlet />
        </main>
      </div>
    </DockProvider>
  );
}
